import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './user.styles'
import { MyAvatar } from 'pobble-components/dist/pobble-avatar'

const User = ({ classes, pending, name }) => {
  return (
    <Fragment>
      <MyAvatar className={classes.avatar} />
      <div>
        <div className={classes.name}>{name}</div>
      </div>
    </Fragment>
  )
}

export default injectSheet(styles)(User)
